import { getDefaultDataForType } from '../utils/contentDefaults';

/**
 * 内容项操作Hook
 */
export function useContentActions(contentItems, setContentItems, setSelectedContentId) {
  // 添加内容项
  const handleAddContent = (type) => {
    const newItem = {
      id: Date.now(),
      type: type,
      data: getDefaultDataForType(type)
    };
    setContentItems(prevItems => [...prevItems, newItem]);
    setSelectedContentId(newItem.id);
  };

  // 删除内容项
  const handleDeleteContent = (id) => {
    setContentItems(prevItems => prevItems.filter(item => item.id !== id));
    setSelectedContentId(null);
  };

  // 更新内容项
  const handleUpdateContent = (id, newData) => {
    setContentItems(prevItems =>
      prevItems.map(item =>
        item.id === id ? { ...item, data: { ...item.data, ...newData } } : item
      )
    );
  };

  // 向上移动
  const handleMoveUp = (id) => {
    setContentItems(prevItems => {
      const index = prevItems.findIndex(item => item.id === id);
      if (index <= 0) return prevItems;
      const newItems = [...prevItems];
      [newItems[index - 1], newItems[index]] = [newItems[index], newItems[index - 1]];
      return newItems;
    });
  };

  // 向下移动
  const handleMoveDown = (id) => {
    setContentItems(prevItems => {
      const index = prevItems.findIndex(item => item.id === id);
      if (index < 0 || index >= prevItems.length - 1) return prevItems;
      const newItems = [...prevItems];
      [newItems[index], newItems[index + 1]] = [newItems[index + 1], newItems[index]];
      return newItems;
    });
  };

  return {
    handleAddContent,
    handleDeleteContent,
    handleUpdateContent,
    handleMoveUp,
    handleMoveDown,
  };
}

